import React, {Component} from 'react';
import { __ } from 'i18n-for-browser';
import PropTypes from "prop-types";
import GoBackButton from '../../elements/GoBackButton';
import PopupTitle from '../../elements/PopupTitle';

import Globas from "../../../assets/img/icons/globas.svg";

export default class FeedbackHeader extends Component {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
    currentRound: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    icon: PropTypes.string,
    disaster: PropTypes.bool,
    hideClose: PropTypes.bool,
    noTitle: PropTypes.bool,
    closeButtonHandler: PropTypes.func,
  };
  static defaultProps = {
    currentRound: 1,
    type: 'budgetkeuze',
    disaster: false,
    hideClose: false,
    noTitle: false,
    closeButtonHandler: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      typeIcon: ''
    };
  }

  componentDidMount() {
    switch(this.props.type) {
      case 'budgetkeuze':
        this.setState({"typeIcon": Globas});
        break;
      case 'beleidskeuze':
        this.setState({"typeIcon": Globas});
        break;
      default:
        this.setState({"typeIcon": Globas});
    }
  }

  getInnerHeader = () => {
    if(this.props.oneLine){
      return (
        <div className={'details'}>
          <span className={'subcontainer'}>
            {
              (!this.props.noTitle ?
                <p className={'type'}>{__(this.props.type)}</p>
                :
                null
              )
            }
            {
              (this.props.popUpTitle)
                ? // @todo wanneer dit dynamisch wordt zorg er dan ook voor dat de tekst ook klikbaar is (indien van toepassing)
                  <PopupTitle popupId={this.props.popUpTitle} tag={'h4'}/>
                : null
            }
          </span>
        </div>
      );
    } else {
      return (
        <div className={'details'}>
          <p className={'round'}>{__('sim_spelronde')} {this.props.currentRound}</p>
          {
            (!this.props.noTitle ?
              <p className={'type'}>{(this.props.prependEffect === true ? __("sim_effect_vanuit") + ": " : "") + __(this.props.type)}</p>
              :
              null
            )
          }
          <span className={'subcontainer'}>
            {
              (this.props.subtitle)
              ?
                <p className={"sub"}>{this.props.subtitle.indexOf(': ') !== -1 ? this.props.subtitle.substr(2) : this.props.subtitle}</p>
              : null
            }

            {
              (this.props.popUpTitle)
                ?
                  <PopupTitle popupId={this.props.popUpTitle} tag={'h3'}/>
                : null
            }

          </span>

        </div>
      );
    }
  }


  render() {
    let disablePoints = false;

    if(this.props.type === "Startsituatie"){
      disablePoints = true;
    }

    return (
      <div className={'feedbackheader'}>
        <div className='inner-feedbackheader'>

          {this.props.icon !== null ?
            <div className='icon'>
              <img alt="icon" src={this.props.icon}/>
            </div> : <div className='no-icon-spacing'/>
          }

          {this.getInnerHeader()}

          {!disablePoints && (this.props.points || this.props.points === 0) ?
            <span className={'point-holder'}>
              <span title={(this.props.miljard && this.props.points > 0 ? "+" : "") + this.props.points}>{(this.props.miljard && this.props.points > 0 ? "+" : "") + this.props.points}</span>
              <p title={this.props.miljard ? __('sim_miljard') : __('sim_punten')}>{this.props.miljard ? __('sim_miljard') : __('sim_punten')}</p>
            </span>
          : '' }

          <div className={'buttons'}>
            {/*
              (this.props.disaster)
                ?
                <div className="disaster">
                  <img alt="disaster" src={Ramp}/>
                </div>
                : null
            */}
            {this.props.hideClose ? <div className="close-button spacer" /> :
              <GoBackButton history={this.props.history} customHandler={this.props.closeButtonHandler}/>
            }
          </div>

        </div>
      </div>
    )

  }
}



// WEBPACK FOOTER //
// ./src/components/elements/feedback/FeedbackHeader.js